// src/aws/cognitoClient.js
import { CognitoIdentityProviderClient } from "@aws-sdk/client-cognito-identity-provider";

export const cognitoClient = new CognitoIdentityProviderClient({
  region: "eu-central-1", // e.g., 'us-east-1'
});
